import { Component, Input, OnInit } from '@angular/core';
import { stringSubstr } from 'src/app/utils.ts/helpers';

@Component({
  selector: 'app-information-loader',
  templateUrl: './information_loader.component.html',
  styleUrls: ['./information_loader.component.scss']
})
export class InformationLoaderComponent{
  @Input() data: any = {};
  substring= stringSubstr;  
}
